'use client';

import { InputHTMLAttributes, MouseEvent } from 'react';
import { RegisterOptions, useFormContext } from 'react-hook-form';

interface Props extends Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange' | 'name' | 'onClick'> {
    errText?: string;
    isHidden?: boolean;
    label?: string;
    labelClassName?: string;
    name: string;
    options?: RegisterOptions;
    onClick?: (e: MouseEvent<HTMLInputElement>) => void; // Correct React-specific MouseEvent
    withError?: boolean;
    withSuccess?: boolean;
    icon?: string;
}

export default function Input(props: Props) {
    const { register } = useFormContext();

    const { errText, isHidden, withError, withSuccess, label, options, onClick, labelClassName, ...rest } = props;

    const inputErrorClass = withError ? '!border-red-600 text-red-600' : '';
    const inputSuccessClass = withSuccess ? '!border-accent' : '';
    const spanErrorClass = withError ? 'opacity-100 text-red-600' : 'opacity-0';

    return (
        <div className="flex w-full flex-col justify-between">
            <label htmlFor={props.name} className={`label ${labelClassName}`}>
                {label}
            </label>
            <div className="relative">
                {withSuccess && (
                    <div className="icon absolute right-2 top-1/2 -translate-y-1/2 rounded-full bg-accent bg-checkbox bg-[length:50%] px-2 py-2" />
                )}
                <input
                    onClick={onClick}
                    {...rest}
                    {...register(props.name, { ...options })}
                    className={`input-primary text-regular w-full md:text-lg ${inputErrorClass} ${inputSuccessClass} ${isHidden ? 'hidden' : ''}`}
                />
                {props.icon && (
                    <span
                        onClick={onClick}
                        className={`icon absolute right-2 top-1/2 h-4 w-4 -translate-y-1/2 cursor-pointer ${props.icon}`}
                    />
                )}
            </div>
            <span className={`h-4 text-xs ${spanErrorClass}`}>{errText}</span>
        </div>
    );
}
